import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDeliverableStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface DeliverableStatusChangedEventProps {
  event: DiscriminatedDeliverableStatusChangedEvent;
}

export const DeliverableStatusChangedEvent: React.FC<
  DeliverableStatusChangedEventProps
> = ({ event }) => {
  const { deliverable, old_status, new_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100">
          <ArrowPathIcon className="h-4 w-4 text-emerald-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {deliverable?.name && <ActivityTitle>{deliverable.name}</ActivityTitle>}
        {old_status && new_status && (
          <ActivityStatusTransition
            from={formatStatus(old_status)}
            to={formatStatus(new_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Deliverable Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
